<template>
    <div class="nk-app-root">
        <!-- main @s -->
        <div class="nk-main ">
            <!-- wrap @s -->
            <div class="nk-wrap nk-wrap-nosidebar">
                <!-- content @s -->
                <div class="nk-content ">
                    <div class="nk-split nk-split-page nk-split-lg">
                        <div class="nk-split-content nk-block-area nk-block-area-column nk-auth-container bg-white">
                            <div class="absolute-top-right d-lg-none p-3 p-sm-5">
                                <a href="#" class="toggle btn-white btn btn-icon btn-light" data-target="athPromo"><em class="icon ni ni-info"></em></a>
                            </div>
                            <div class="nk-block nk-block-middle nk-auth-body">
                                <div class="brand-logo pb-5">
                                    <a href="javascript:void(0)" class="logo-link">
                                        <img class="logo-light logo-img logo-img-lg" src="/images/logo.png" alt="logo">
                                        <img class="logo-dark logo-img logo-img-lg" src="/images/logo.png" alt="logo-dark">
                                    </a>
                                </div>
                                <div class="nk-block-head">
                                    <div class="nk-block-head-content">
                                        <h5 class="nk-block-title">Reset Password</h5>

                                    </div>
                                </div><!-- .nk-block-head -->

                                <div class="form-group">
                                    <div class="form-label-group">
                                        <label class="form-label" for="email-address">Password</label>
                                    </div>
                                    <div class="form-control-wrap">
                                        <a tabindex="-1" href="javascript:void(0)" class="form-icon form-icon-right passcode-switch lg" data-target="password">
                                            <em class="passcode-icon icon-show icon ni ni-eye"></em>
                                            <em class="passcode-icon icon-hide icon ni ni-eye-off"></em>
                                        </a>
                                        <input v-model="login.password" @keyup.enter="SaveNewUser" type="password" class="form-control form-control-lg" required id="password" placeholder="Enter your Password">
                                    </div>
                                </div><!-- .form-group -->
                                <div class="form-group">
                                    <div class="form-label-group">
                                        <label class="form-label" for="password">Confirm Password</label>
                                    </div>
                                    <div class="form-control-wrap">
                                        <a tabindex="-1" href="javascript:void(0)" class="form-icon form-icon-right passcode-switch lg" data-target="confirmPassword">
                                            <em class="passcode-icon icon-show icon ni ni-eye"></em>
                                            <em class="passcode-icon icon-hide icon ni ni-eye-off"></em>
                                        </a>
                                        <input v-model="login.confirmPassword" @keyup.enter="SaveNewUser" type="password" class="form-control form-control-lg" required id="confirmPassword" placeholder="Enter your Confirm Password">
                                    </div>
                                </div><!-- .form-group -->
                                <div class="form-group">
                                    <div class="nk-block-des">
                                        <p>{{ customError }}</p>
                                    </div>
                                    <button v-bind:disabled="$v.$invalid" v-on:click="SaveNewUser" class="btn btn-lg btn-primary btn-block">Reset</button>
                                </div>

                                <div class="form-note-s2 pt-4">
                                    Back to ? <a href="javascript:void(0)" v-on:click="GoToSignup()">Login account</a>
                                </div>

                            </div><!-- .nk-block -->
                            <div class="nk-block nk-auth-footer">
                                <div class="nk-block-between">
                                    <ul class="nav nav-sm">
                                        <li class="nav-item">
                                            <a v-on:click="GoToTerms()" class="nav-link" href="javascript:void(0)">Terms & Condition</a>
                                        </li>
                                        <li class="nav-item">
                                            <a v-on:click="GoToPrivacy()" class="nav-link" href="javascript:void(0)">Privacy Policy</a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" href="javascript:void(0)">Help</a>
                                        </li>
                                        <li class="nav-item dropup">
                                            <a class="dropdown-toggle dropdown-indicator has-indicator nav-link" data-bs-toggle="dropdown" data-offset="0,10"><small>English</small></a>
                                            <div class="dropdown-menu dropdown-menu-sm dropdown-menu-end">
                                                <ul class="language-list">
                                                    <li>
                                                        <a href="#" class="language-item">
                                                            <img src="/images/flags/english.png" alt="" class="language-flag">
                                                            <span class="language-name">English</span>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="#" class="language-item">
                                                            <img src="/images/flags/turkey.png" alt="" class="language-flag">
                                                            <span class="language-name">T�rk�e</span>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </li>
                                    </ul><!-- .nav -->
                                </div>
                                <div class="mt-3">
                                    <p>&copy; 2022 Black Stone Capitals. All Rights Reserved.</p>
                                </div>
                            </div><!-- .nk-block -->
                        </div><!-- .nk-split-content -->
                        <div class="nk-split-content nk-split-stretch bg-lighter d-flex toggle-break-lg toggle-slide toggle-slide-right" data-toggle-body="true" data-content="athPromo" data-toggle-screen="lg" data-toggle-overlay="true">
                            <div class="slider-wrap w-100 w-max-550px p-3 p-sm-5 m-auto">
                                <div class="slider-init">
                                    <div class="slider-item">
                                        <div class="nk-feature nk-feature-center">
                                            <div class="nk-feature-img">
                                                <img class="round" src="/images/login.svg" srcset="/images/login.svg" alt="">
                                            </div>
                                            
                                        </div>
                                    </div><!-- .slider-item -->

                                </div><!-- .slider-init -->
                                <div class="slider-dots"></div>
                                <div class="slider-arrows"></div>
                            </div><!-- .slider-wrap -->
                        </div><!-- .nk-split-content -->
                    </div><!-- .nk-split -->
                </div>
                <!-- wrap @e -->
            </div>
            <!-- content @e -->
        </div>
        <!-- main @e -->
        <forgot-password :show="show" v-if="show" @close="show=false" />

        <loading :name="loading" :active.sync="loading"
                 :can-cancel="false"
                 :is-full-page="true"></loading>
    </div>
    <!-- app-root @e -->

</template>
<script>
    import { required, sameAs} from 'vuelidate/lib/validators';
    import Loading from 'vue-loading-overlay';
    import "vue-loading-overlay/dist/vue-loading.css";

    export default {
        components: {
            Loading
        },
        data() {
            return {
                loading: false,
                show: false,
                login: {
                    id: '',
                    password: '',
                    confirmPassword: ''
                },
                error: '',
                customError: ''
            }
        },
        validations: {
            login:
            {
                id:
                {
                    required
                },
                password:
                {
                    required,
                    strongPassword(password) {
                        return /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/.test(password);
                    }
                },
                confirmPassword:
                {
                    required,
                    sameAsPassword: sameAs('password')
                },
            }
        },

        methods: {
            GoToTerms: function () {
                this.$router.push('/TermsAndCondition')
            },

            GoToPrivacy: function () {
                this.$router.push('/TermsAndCondition')
            },

            GoToSignup: function () {
                this.$router.push('/')
            },

            SaveNewUser: function () {
                var root = this;
                this.loading = true;
                
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https.get('/account/ResetPassword?id=' + this.login.id + '&password=' + this.login.password + '&confirmPassword=' + this.login.confirmPassword, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        
                        if (response.data.id != '00000000-0000-0000-0000-000000000000' && response.data.isSuccess) {

                            root.$swal({
                                title: 'Reset!',
                                text: 'Your Password has been Changed successfully.',
                                type: 'success',
                                icon: 'success',
                                confirmButtonClass: "btn btn-success",
                                buttonsStyling: false
                            });
                            root.loading = false;
                            //root.SendEmailVerification(response.data.id);

                            root.$router.push('/')
                        }
                        else {
                            root.$swal({
                                title: 'Error!',
                                text: response.data.isAddUpdate,
                                type: 'error',
                                icon: 'error',
                                confirmButtonClass: "btn btn-info",
                                buttonsStyling: false
                            });
                            root.loading = false;
                        }
                    }).catch(error => {
                        console.log(error)
                        root.$swal.fire(
                            {
                                icon: 'error',
                                type: 'error',
                                title: 'Error',
                                text: "Something Went Wrong",
                                showConfirmButton: false,
                                timer: 5000,
                                timerProgressBar: true,
                            });

                        root.loading = false;
                    })
                    .finally(() => root.loading = false);
            },

            SendEmailVerification: function (id) {
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                
                this.$https.get('/account/SendResetEmail?id=' + id, { headers: { "Authorization": `Bearer ${token}` } });

            },
        },
        created: function () {
            this.login.id = this.$route.query.id;
        },
    }
</script>
